import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { SummaryTableStyle } from '../styles';
import { handleScroll, updateRefScrollPosition } from '@utils/handleScroll';
import { usePresentation } from '@context/presentation';
import { retrieveScrollPosition } from '@utils/browserStorage';
import { SCROLL_IDS } from '@constants';
import { isValidNumber } from '@utils/validateInputs';

export const SummaryTable = ({ currentSituation, proposedSituations, selectedTerm }) => {
    const tableRef = useRef(null);
    const { t } = useTranslation();
    const { clientViewing } = usePresentation();
    const { desktop, slideState } = useSlideData();
    const selectedSituation = proposedSituations[selectedTerm];
    const { proposedTerms, savings } = selectedSituation;
    const scrollId = SCROLL_IDS.summaryTable;
    const currentScrollPosition = slideState.scrollLeft ? slideState.scrollLeft[scrollId] : null;

    useEffect(() => {
        if (isValidNumber(currentScrollPosition) && clientViewing) {
            updateRefScrollPosition(tableRef, currentScrollPosition, 'scrollLeft');
        }
    }, [tableRef, currentScrollPosition]);

    useEffect(() => {
       retrieveScrollPosition(scrollId, tableRef);
    }, [tableRef])

    return (
        <SummaryTableStyle
            ref={tableRef}
            onScroll={event => handleScroll(event, scrollId, clientViewing)} 
            desktop={desktop}
            scrollId={scrollId}>
            <thead>
                <tr>
                    <th></th>
                    <th>{t('summary.current_situation')}</th>
                    <th>{t('summary.proposed_terms')}</th>
                    <th>{t('global.savings')}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{t('summary.time_to_pay_off')}</td>
                    <td>{currentSituation.timeToPayOff} {t('global.years')}</td>
                    <td>{proposedTerms.timeToPayOff} {t('global.years')}</td>
                    <td>{savings.savingsInYears} {t('global.years')}</td>
                </tr>
                <tr>
                    <td>{t('summary.total_payments')}</td>
                    <td>{currentSituation.totalPayment}</td>
                    <td>{proposedTerms.totalPayment}</td>
                    <td>{savings.totalSavings}</td>
                </tr>
                <tr>
                    <td>{t('summary.monthly_payments')}</td>
                    <td>{currentSituation.monthlyPayments}</td>
                    <td>{proposedTerms.newMonthlyPayment}</td>
                    <td>{savings.monthlySavings}</td>
                </tr>
            </tbody>
        </SummaryTableStyle>
    );
};

export default SummaryTable;